import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {Form} from 'react-final-form';
import {Link, MediaConfiguration, Button, SelectField, TextField, PulseLoader} from '../../../common';
import {NOMEDIASOURCE} from '../../../../configs/constants';
import {appId} from '../../../../store';
import {forwardTo} from '../../../../utils';

const PREFIX = 'f_';

export default class JoinGame extends Component {
  static propTypes = {
    ableToSendGiftsForFree: PropTypes.bool.isRequired,
    branchIoLink: PropTypes.string.isRequired,
    onJoinGame: PropTypes.func.isRequired,
    onConfirmMedia: PropTypes.func.isRequired,
    fetchGameTeamDefinition: PropTypes.func.isRequired,
    fetchMobileBranchIoLink: PropTypes.func.isRequired,
    saveUserDefinitions: PropTypes.func.isRequired,
    currentGame: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      hasAlreadyJoined: PropTypes.bool,
    }).isRequired,
    currentTeamDefinition: PropTypes.shape({
      leftTeamName: PropTypes.string,
      rightTeamName: PropTypes.string,
      playerDefinition: PropTypes.arrayOf(PropTypes.string),
      teamDefinition: PropTypes.shape({
        preselected: PropTypes.string,
        field: PropTypes.string,
        values: PropTypes.arrayOf(PropTypes.string),
      }),
    }).isRequired,
    color: PropTypes.string.isRequired,
    barColor: PropTypes.string.isRequired,
    isAudienceAllowed: PropTypes.bool,
    fetchingCurrentTeamDefinition: PropTypes.bool.isRequired,
    redirect: PropTypes.bool,
    isLandingShowed: PropTypes.bool,
  };

  static defaultProps = {
    isLandingShowed: false,
    isAudienceAllowed: false,
    redirect: true,
  };

  state = {
    currentGame: null,
    isJoinAsPlayerClicked: false,
    hasTeamSelected: false,
  };

  componentWillReceiveProps(nextProps) {
    const {currentTeamDefinition: {teamDefinition: {preselected}}} = nextProps;
    this.setState({hasTeamSelected: preselected || false});
  }

  async componentDidMount() {
    const {currentGame: {id: gameId}} = this.props;

    const vh = window.innerHeight * 0.01;
    if (window.innerWidth < 700) {
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('overflow', 'hidden');
      document.documentElement.classList.add('join-in-progress');
      window.addEventListener('resize', this.resizeHandler);
    }

    /*
    if (isMobile) {
      this.props.fetchMobileBranchIoLink({appId, gameId});
    }
    */

    this.props.fetchGameTeamDefinition({appId, gameId});
  }

  componentWillUnmount() {
    if (window.innerWidth < 700) {
      document.documentElement.style.setProperty('overflow', 'scroll');
      document.documentElement.classList.remove('join-in-progress');
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  onClickBack = () => {
    const isTeamDefinition = this.needAdditionalFields();
    this.setState({
      hasTeamSelected: false,
      definitionValue: false,
      isJoinAsPlayerClicked: isTeamDefinition,
    });
  };

  onBackButtonClick = () => {
    this.setState({
      isJoinAsPlayerClicked: false,
      definitionValue: false,
    });
  }

  onConfirmUserMedia = ({audioSource, videoSource}) => {
    const {
      currentGame: {id: gameId}, onJoinGame, onConfirmMedia, redirect,
      currentTeamDefinition: {teamDefinition: {preselected}},
    } = this.props;
    const {definitionValue} = this.state;
    const definitionToSend = definitionValue || preselected;

    const videoSourceValue = videoSource === NOMEDIASOURCE ? null : videoSource;
    const audioSourceValue = audioSource === NOMEDIASOURCE ? null : audioSource;

    onConfirmMedia({audioSource: audioSourceValue, videoSource: videoSourceValue});
    onJoinGame({appId, gameId, type: 'player', definitionValue: definitionToSend, redirect});
  };

  onClickJoinAsAudience = () => {
    const {currentGame: {id: gameId}, onJoinGame, redirect} = this.props;

    onJoinGame({appId, gameId, type: 'audience', redirect});
  };

  onClickJoinAsPlayer = () => {
    this.setState({isJoinAsPlayerClicked: true});
  };

  onFormSubmit = (values) => {
    const {
      saveUserDefinitions,
      currentTeamDefinition: {teamDefinition},
      currentGame: {id: gameId},
    } = this.props;
    const data = Object.keys(values).map(
      key => ({field: key.substring(2), value: values[key]})
    );

    saveUserDefinitions({data, gameId});

    this.setState({
      hasTeamSelected: true,
      definitionValue: values[`${PREFIX}${teamDefinition.field}`],
    });
  }

  needAdditionalFields = () => {
    const {currentTeamDefinition: {teamDefinition, playerDefinition}} = this.props;

    return (teamDefinition.field && !isEmpty(teamDefinition.values) && !teamDefinition.preselected)
      || !isEmpty(playerDefinition);
  }

  goToLanding = () => {
    forwardTo('/gift');

    return null;
  }

  renderGiftLanding = () => {
    const {
      currentGame, barColor, isLandingShowed, ableToSendGiftsForFree,
    } = this.props;

    return (
      isLandingShowed || ableToSendGiftsForFree ?
        (
          <div>
            Please check that your camera,
            <br/>microphone and volume are turned on.

            <MediaConfiguration
              defaultAudioSource={null}
              defaultVideoSource={null}
              onConfirmUserMedia={this.onConfirmUserMedia}
              onClickBack={this.onClickBack}
              currentGame={currentGame}
              barColor={barColor}
            />
          </div>
        )
        : this.goToLanding()
    );
  }

  renderBodyForPlayer = () => {
    const {
      currentGame,
    } = this.props;

    return (
      !currentGame.hasAlreadyJoined && this.needAdditionalFields() ?
        this.renderChooseTeam() :
        this.renderGiftLanding()
    );
  }

  renderTeamDefinitionField = () => {
    const {currentTeamDefinition: {teamDefinition}} = this.props;

    if (!teamDefinition.field) {return (<div/>);}

    const options = teamDefinition.values.map(value =>
      ({label: value, value})
    );

    return (
      <Fragment>
        <div className="form__row_gap_xs text-left" key={teamDefinition.field}>
          <label className="form__label" htmlFor={teamDefinition.field}>
            {teamDefinition.field}<span className="form__label_asteriks">*</span>
          </label>
          <SelectField
            name={`${PREFIX}${teamDefinition.field}`}
            placeholder="Choose option"
            options={options}
            errorPosition="top right"
            required
          />
        </div>
      </Fragment>
    );
  }

  renderPlayerDefinitionFields = () => {
    const {currentTeamDefinition: {playerDefinition}} = this.props;
    if (!playerDefinition.length) {return (<div/>);}

    return (
      <Fragment>
        {
          playerDefinition.map(field => (
            <TextField
              label={field}
              name={`${PREFIX}${field}`}
              key={`${PREFIX}${field}`}
              errorPosition="top right"
              required
              asterisk
            />
          ))
        }
      </Fragment>
    );
  }

  isSubmitDisabled = values => Object.keys(values).some(key => !values[key])

  renderChooseTeam = () => {
    const {
      currentTeamDefinition: {teamDefinition, playerDefinition},
      fetchingCurrentTeamDefinition,
    } = this.props;

    if (fetchingCurrentTeamDefinition) {
      return <PulseLoader/>;
    }

    if (isEmpty(teamDefinition) && !fetchingCurrentTeamDefinition) {
      this.setState({hasTeamSelected: true});
      return <div/>;
    }

    const initialValues = {};

    if (playerDefinition.length) {
      playerDefinition.forEach((key) => {
        initialValues[`${PREFIX}${key}`] = '';
      });
    }

    if (teamDefinition.preselected) {
      initialValues[`${PREFIX}${teamDefinition.field}`] = teamDefinition.preselected;
    }

    return (
      <div>
        <Form
          onSubmit={this.onFormSubmit}
          initialValues={initialValues}
          render={({handleSubmit, values}) => (
            <form className="text-left" onSubmit={handleSubmit}>
              {
                !teamDefinition.preselected && this.renderTeamDefinitionField()
              }
              {
                this.renderPlayerDefinitionFields()
              }
              <div className="row row_center">
                <Button
                  size="xl"
                  text="Back"
                  handler={this.onBackButtonClick}
                />
                <Button
                  size="xl"
                  type="submit"
                  text="Next"
                  disabled={this.isSubmitDisabled(values)}
                />
              </div>
            </form>
          )}
        />
      </div>
    );
  }

  renderAlreadyJoined = () => (
    <div>
      <h2>You have already joined this game</h2>
      <Link onClick={this.onClickJoinAsPlayer} theme="primary" size="xm" type="button" text="Continue"/>
    </div>
  );

  renderBodyForAudience = () => {
    const {isAudienceAllowed, currentGame, currentGame: {hasAlreadyJoined}, color} = this.props;

    return (
      <div>
        <div className="text-xxxx-big">You selected to enter</div>
        <h3 className="text-xxxx-big text-blue row_gap_m" style={{color}}>{currentGame.name}</h3>
        {
          hasAlreadyJoined ?
            this.renderAlreadyJoined() :
            (
              <div className="row row_center">
                <Link onClick={this.onClickJoinAsPlayer} theme="primary" size="xm" type="button" text="Join as a player"/>
                {(isAudienceAllowed && currentGame.isAudienceAllowed) &&
                  <Button handler={this.onClickJoinAsAudience} theme="primary" size="xm" type="button" text="Join as an audience member"/>
                }
              </div>
            )
        }
      </div>
    );
  };

  render() {
    const {isJoinAsPlayerClicked} = this.state;
    // const {branchIoLink} = this.props;

    /*
    if (isMobile) {
      return (
        <div>
          {branchIoLink && (
            <div className="join-game-mobile-app">
              <p>In order to play a Yak Network Game, first download the mobile app.</p>
              <a href={branchIoLink} className="button button_rounded button_primary button_size_l">
                Click here to join the game
              </a>
            </div>
          )}
        </div>
      );
    }
    */

    return (
      isJoinAsPlayerClicked ?
        this.renderBodyForPlayer() :
        this.renderBodyForAudience()
    );
  }
}
